import styled, { css } from 'styled-components';
import {
  getSpace,
  px2rem,
  mq,
  getGridSpan,
  hideVisually,
  getGridSpans,
  emulateFocus
} from '../../../stylesheets/tools';

const StyledExhibitionContainer = styled.div`
  margin: ${getSpace('xxl')} 0;

  .exhibitionContainer__module {
    display: flex;
    flex-flow: column;
    margin: 4rem 0;

    .exhibitionContainer__module-end-icon {
      margin: auto;
      display: block;
    }

    .exhibitionContainer__module-even.exhibitionContainer__module-left,
    .exhibitionContainer__module-odd.exhibitionContainer__module-right {
      transform: scale(-1, 1);
    }

    .exhibitionContainer__module-quote {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  .exhibitionContainer__module--didYouKnow + .exhibitionContainer__module--quote {
    padding-top: 12rem;
  }
`;

const StyledExhibitionStations = styled.div`
  .exhibitionContainer__stations {
    margin-top: ${getSpace('xl')};

    ${mq('m')} {
      margin-top: ${getSpace('xxl')};
    }

    .container__wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;

      ${mq('m')} {
        flex-direction: ${props => (props.alignment === 'left' ? 'row' : 'row-reverse')};
      }
    }
  }

  .exhibitionContainer__module {
    width: 100%;
    background-color: red;

    .exhibitionContainer__module-type {
      margin: 2rem 0;
    }

    .exhibitionContainer__module-end-icon {
      margin: auto;
      display: block;
    }

    .exhibitionContainer__module-even.exhibitionContainer__module-left,
    .exhibitionContainer__module-odd.exhibitionContainer__module-right {
      transform: scale(-1, 1);
    }

    .exhibitionContainer__module-quote {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  .exhibitionContainer__teaser-info {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;

    margin-bottom: ${getSpace('xl')};

    ${mq('m')} {
      margin-bottom: ${getSpace('xxl')};
    }
  }

  .exhibitionContainer__teaser-info-wrapper {
    position: relative;
  }

  .exhibitionContainer__teaser-info-wrapper-has-timestamp {
    cursor: pointer;
  }

  .exhibitionContainer__info-count {
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 3px solid #000;
    background-color: #fff;
    border-radius: 100%;
    width: ${px2rem('83px')};
    height: ${px2rem('83px')};

    span {
      margin-bottom: 0;
    }

    span:not(:first-of-type) {
      display: none;
    }
  }

  .exhibitionContainer__info-icon {
    flex-shrink: 0;
    display: block;
  }

  .exhibitionContainer__info-icon.only-mobile {
    ${mq('m')} {
      display: none;
    }
  }

  .exhibitionContainer__info-icon.no-mobile {
    margin-top: ${px2rem('23px')};
    display: none;

    ${mq('m')} {
      display: block;
    }
  }

  .exhibitionContainer__info-trigger {
    ${hideVisually()};
  }

  .exhibitionContainer__info-trigger:checked + .exhibitionContainer__info-count {
    width: ${px2rem('121px')};
    height: ${px2rem('121px')};

    span,
    svg {
      display: block;
    }
  }

  .exhibitionContainer__info-trigger:focus + .exhibitionContainer__info-count {
    ${emulateFocus}
  }

  .exhibitionContainer__teaser-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${mq('m')} {
      &--s {
        width: ${getGridSpan(6)};
      }

      &--m {
        width: 100%;
      }
    }
  }

  ${props =>
    props.alignment &&
    css`
      .exhibitionContainer__teaser-wrapper:nth-of-type(odd) .exhibitionContainer__info-icon,
      .exhibitionContainer__teaser-wrapper:nth-of-type(even) .exhibitionContainer__end-icon {
        transform: ${props.alignment === 'left' ? 'scale(-1,1)' : ''};
      }

      .exhibitionContainer__teaser-wrapper:nth-of-type(even) .exhibitionContainer__info-icon,
      .exhibitionContainer__teaser-wrapper:nth-of-type(odd) .exhibitionContainer__end-icon {
        transform: ${props.alignment === 'left' ? '' : 'scale(-1,1)'};
      }

      ${mq('m')} {
        .exhibitionContainer__teaser-wrapper--s {
          &:nth-of-type(odd) {
            .exhibitionContainer__teaser-info {
              justify-content: ${props.alignment === 'left' ? 'flex-end' : 'flex-start'};
            }
            .exhibitionContainer__end-icon {
              align-self: ${props.alignment === 'left' ? 'flex-end' : 'flex-start'};
            }
          }

          &:nth-of-type(even) {
            .exhibitionContainer__teaser-info {
              justify-content: ${props.alignment === 'left' ? 'flex-start' : 'flex-end'};
            }
            .exhibitionContainer__end-icon {
              align-self: ${props.alignment === 'left' ? 'flex-start' : 'flex-end'};
            }
          }
        }

        .exhibitionContainer__teaser-wrapper--m {
          &:nth-of-type(odd) .exhibitionContainer__teaser-info-wrapper {
            ${props.alignment === 'left' ? 'margin-left: 100px' : 'margin-right: 100px'};
          }

          &:nth-of-type(even) .exhibitionContainer__teaser-info-wrapper {
            ${props.alignment === 'left'
              ? `margin-right: ${px2rem('100px')}`
              : `margin-left: ${px2rem('100px')}`};
          }
        }

        ${props.clusterIndex === 0 &&
          css`
            .exhibitionContainer__teaser-wrapper:nth-of-type(1) {
              .exhibitionContainer__teaser-info {
                justify-content: center;
              }
            }
          `}
      }
    `}

  .exhibitionContainer__teaser-wrapper--s .exhibitionContainer__teaser-info {
    ${getGridSpans('margin-right', { s: 0, m: [1, 'spread', 6] })};
  }

  .exhibitionContainer__teaser-no-img
    + .exhibitionContainer__teaser-wrapper
    .exhibitionContainer__teaser-info {
    margin-right: 0;
  }

  ${props =>
    props.stationLength === 3 &&
    css`
      .container__wrapper {
        justify-content: center;
      }

      .exhibitionContainer__teaser-wrapper:nth-of-type(3) {
        margin-bottom: ${getSpace('80px')};
        margin-right: 1px;
      }

      ${mq('m')} {
        .exhibitionContainer__teaser-wrapper:nth-of-type(1) {
          margin-top: 0;
          ${props.alignment === 'left'
            ? `margin-right: ${px2rem('10px')}`
            : `margin-left: ${px2rem('10px')}`};
        }
        .exhibitionContainer__teaser-wrapper:nth-of-type(2) {
          margin-top: ${px2rem('350px')};
        }
      }
    `};

  ${props =>
    props.stationLength !== 3 &&
    css`
      .exhibitionContainer__teaser-wrapper:last-of-type {
        margin-bottom: ${getSpace('80px')};
      }
      ${mq('m')} {
        .exhibitionContainer__teaser-wrapper:nth-of-type(odd) {
          ${props.alignment === 'left'
            ? `margin-right: ${px2rem('10px')}`
            : `margin-left: ${px2rem('10px')}`};
          margin-top: ${px2rem('-100px')};
        }

        .exhibitionContainer__teaser-wrapper:nth-of-type(even) {
          margin-top: ${px2rem('250px')};
        }

        .exhibitionContainer__teaser-wrapper:nth-of-type(1) {
          margin-top: 0;
        }

        .exhibitionContainer__teaser-wrapper:nth-of-type(2) {
          margin-top: ${px2rem('500px')};
        }
      }
    `}
`;

export { StyledExhibitionContainer, StyledExhibitionStations };
